import type { ReactNode } from "react";
import { useAuth } from "../hooks/useAuth";
import { LoginPage } from "@/pages/LoginPage";

interface AuthGuardProps {
  children: ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { status } = useAuth();

  if (status === "loading") {
    return <LoadingScreen />;
  }

  if (status === "unauthenticated") {
    return <LoginPage />;
  }

  return <>{children}</>;
}

function LoadingScreen() {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-4">
        {/* Logo mark with pulse animation */}
        <div className="relative">
          <div
            className="w-14 h-14 rounded-xl bg-primary/10 border border-primary/20
                       flex items-center justify-center animate-pulse"
          >
            <svg
              viewBox="0 0 24 24"
              className="w-7 h-7 text-primary"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 2L2 7l10 5 10-5-10-5z" />
              <path d="M2 17l10 5 10-5" />
              <path d="M2 12l10 5 10-5" />
            </svg>
          </div>
          {/* Glow effect */}
          <div
            className="absolute inset-0 rounded-xl blur-xl opacity-30 animate-pulse"
            style={{ background: "var(--primary)" }}
          />
        </div>

        <p className="text-sm text-foreground-muted">Loading...</p>
      </div>
    </div>
  );
}
